<template>
  <div class="scroll-panel"
    :class="{
      'is-pinned': isPinned,
      'is-scroll-disabled': isScrollDisabled,
      'has-padding': hasPadding
    }"
    :style="style">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number | String,
        default: -1
      },
      useMax: {
        type: Boolean,
        default: false
      },
      isScrollDisabled: {
        type: Boolean,
        default: false
      },
      isPinned: {
        type: Boolean,
        default: false
      },
      hasPadding: {
        type: Boolean,
        default: true
      },
      hideXOverflow: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number | String | null,
        default: null
      }
    },
    computed: {
      style () {
        const style = {}
        style['height'] = this.localHeight
        style['overflow-x'] = this.hideXOverflow ? 'hidden' : null
        if (this.width) {
          style['width'] = this.width + 'px'
        }
        return style
      },
      localHeight () {
        return this.height === -1 ? 'auto' : (typeof this.height === 'string' ? this.height : this.height + 'px')
      }
    }
  }
</script>

<style lang="scss">
  .scroll-panel {
    &:not(.is-scroll-disabled) {
      overflow-y: auto;
      &.has-padding {
        padding-right: rem(15);
      }
      // We want to check if we are in webkit so we can style and add spacing for custom scroll bars
      @supports (-webkit-appearance: none) {
        overflow-y: scroll;

        &.has-padding {
          padding-right: rem(12);
          margin-right: rem(2);
        }
      }
    }

    &::-webkit-scrollbar {
      width: rem(6);
    }

    &::-webkit-scrollbar-thumb {
      background-color: color(grays, light);
      border-radius: rem(10);
    }

    &.is-pinned {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// ScrollPanel.vue?79cbf8fd